module.exports = __webpack_public_path__ + "static/fonts/Fact-Light.7ba6dc0.woff";